import styled from 'styled-components';


export const Wrapper = styled.div`
    display:flex;
    flex-direction: column;
`

export const WrapperTables = styled.div`
    margin:3px 0
`